import { render, staticRenderFns } from "./disneyPlusTermsOfUse.vue?vue&type=template&id=54860d8a&scoped=true"
import script from "./disneyPlusTermsOfUse.vue?vue&type=script&lang=js"
export * from "./disneyPlusTermsOfUse.vue?vue&type=script&lang=js"
import style0 from "./disneyPlusTermsOfUse.vue?vue&type=style&index=0&id=54860d8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54860d8a",
  null
  
)

export default component.exports